module.exports = __webpack_public_path__ + "static/police-cortez-aa0ef1ebcb4418c60d0f47c56f78f670.gif";